module.exports = __webpack_public_path__ + "img/service-time.249a0633.png";